import React, { PureComponent } from 'react';
import $ from 'jquery';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import * as HTML_RENDITION from '../utils/general/general';
import UserAgentUtils from '../utils/general/userAgentUtils';
import FpDiscText from '../components/fpDiscText';
import { enterKeyPressed } from '../utils/general/enterKey';
import _ from 'lodash';

interface IHealthWarningProps {
    fpDisc: { data: {}, header: { data: {} } };
    showOldBranding: boolean;
}

export class HealthWarning extends PureComponent<IHealthWarningProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            finalDom: true
        };
    }

    public closeHealthWarningFun(event: any) {
        event.stopPropagation();
        this.setState({
            finalDom: false
        });
    }

    public healthWarningBehavior() {
        const scrollTarget: any = (deviceInfoService.isIE() && HTML_RENDITION.isAppInsideIFrame()) ? $('body') : $(window);        
        let scrollCheckTimer: any = null;
        scrollTarget.on('scroll.healthWarning', (e: any) => {
            const _this: any = this;
            clearTimeout(scrollCheckTimer);
            const warningBody = $('#health_warning');
            const scrollTopLimitForHW = UserAgentUtils.isMobile.any() ? (scrollTarget.height() * 2) : (scrollTarget.height() / 2);
            
            scrollCheckTimer = setTimeout(() => {
                if (scrollTarget.scrollTop() < scrollTopLimitForHW) {
                    warningBody.show().prop('hidden', false);
                } else {
                    warningBody.hide().prop('hidden', true);
                }
            }, 100);            
        });        
    }

    public componentDidMount() {
        this.healthWarningBehavior();
    }

    public render() {
        if (HTML_RENDITION.isAuthPreview()){
            return null;
        }
        const { fpDisc } = this.props;

        const productCode = window.HTML_RENDITION.initialData?.productCode;
        const isPodcast = _.isEqual('podcast', productCode?.toLowerCase());
        return this.state.finalDom && !isPodcast &&
            (<div id='health_warning' className='health_warning float_disclosure cf' style={{ display: 'block', maxWidth: '1280px' }} role="contentinfo"
                  aria-label="float disclosure">
                <FpDiscText fpDisc={fpDisc}/>
                <span className='warning_close' tabIndex={0} role='button' aria-label='Close Disclosure'
                      onClick={(e) => this.closeHealthWarningFun(e)} 
                      onKeyPress={(e) => enterKeyPressed(e, this.closeHealthWarningFun.bind(this, e))}>{this.props.showOldBranding ? "" : "x"}</span>
            </div>);
    }
}

export default HealthWarning;
